import React from 'react';
import { Link } from 'react-router-dom';
import IC6Logo from '../images/Logo/IC6_Blue.png';
import IC7Logo from '../images/Logo/ic7_orange.png';
import IC7PlusLogo from '../images/Logo/ic7_plus_orange.png';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function AboutAndSolutions() {
    return (
        <section
            id="about-and-solutions"
            className="relative py-16 sm:py-20 lg:py-24"
        >
            <div
                className="absolute inset-0 pointer-events-none"
                aria-hidden="true"
                style={{
                    background:
                        'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.4), rgba(0,0,0,0.6))',
                }}
            />

            <div
                className="relative z-10 mx-auto w-full max-w-6xl px-12 py-12 sm:px-6 lg:px-8 rounded-3xl border border-gray-800 bg-gray-900 bg-opacity-90 shadow-2xl"
                data-aos="fade-in"
                data-aos-duration="1500"
                data-aos-anchor-placement="top-bottom"
            >
                <div className="flex flex-col gap-10 lg:flex-row lg:items-center mb-12">
                    {/* Video */}
                    <div className="w-full lg:w-1/2">
                        <div className="relative block w-full overflow-hidden rounded-2xl shadow-2xl">
                            <video
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="h-full w-full object-cover"
                                style={{ borderRadius: '16px' }}
                            >
                                <source
                                    src="https://agmtwebsitevideo.s3.eu-west-1.amazonaws.com/IC6Square.mp4"
                                    type="video/mp4"
                                />
                            </video>
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2">
                        <div className="max-w-xl">
                            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mb-4">
                                Modern technology, built for scale
                            </h2>
                            <p className="text-sm sm:text-base text-gray-200 leading-relaxed mb-4">
                                AGMT solutions support insurers, fleets and critical assets through compact sensing hardware designed for fast, self-install deployment. From peel-and-stick devices to solar-powered and bespoke modules, every solution is engineered for simplicity, reliability and scale. All hardware connects into a unified platform, delivering a consistent view of risk, behaviour and performance.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid gap-6 md:grid-cols-2">
                    {/* IC6 */}
                    <Link
                        to="/telematics?device=ic6"
                        className="block h-full"
                        data-aos="fade-up"
                    >
                        <article className="flex flex-col h-full rounded-2xl bg-gray-900 bg-opacity-90 border border-gray-700 shadow-xl p-6 transition transform hover:-translate-y-1 hover:shadow-2xl hover:border-blue-500">
                            <div className="flex items-center mb-4">
                                <img
                                    src={IC6Logo}
                                    alt="IC6 logo"
                                    className="h-10 w-auto mr-3"
                                />
                                <div>
                                    <h3 className="text-base sm:text-lg font-semibold text-white">
                                        Self-install UBI device
                                    </h3>
                                    <p className="text-xs text-blue-400 mt-1">
                                        Peel-and-stick technology for usage-based insurance.
                                    </p>
                                </div>
                            </div>
                            <p className="text-sm sm:text-base text-gray-100 leading-relaxed mb-4">
                                Battery-powered, windscreen-mounted sensing hardware with integrated GPS and motion sensors. Pairs with a smartphone to capture driving behaviour, journeys and collisions without wiring or engineer visits.
                            </p>
                            <div className="mt-auto flex flex-wrap gap-2 text-[11px] text-gray-200">
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    1 year lifespan
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    BLE to mobile app
                                </span>
                            </div>
                        </article>
                    </Link>

                    {/* IC7 */}
                    <Link
                        to="/telematics?device=ic7"
                        className="block h-full"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <article className="flex flex-col h-full rounded-2xl bg-gray-900 bg-opacity-90 border border-gray-700 shadow-xl p-6 transition transform hover:-translate-y-1 hover:shadow-2xl hover:border-yellow-400">
                            <div className="flex items-center mb-4">
                                <img
                                    src={IC7Logo}
                                    alt="IC7 logo"
                                    className="h-10 w-auto mr-3"
                                />
                                <div>
                                    <h3 className="text-base sm:text-lg font-semibold text-white">
                                        Long-life solar device
                                    </h3>
                                    <p className="text-xs text-yellow-400 mt-1">
                                        3–5 year deployments for fleets and assets.
                                    </p>
                                </div>
                            </div>
                            <p className="text-sm sm:text-base text-gray-100 leading-relaxed mb-4">
                                Solar-powered sensing hardware with integrated GPS and motion sensors, backed by a backup battery. Designed for long-life UBI, fleet and asset deployments without wiring or engineer visits.
                            </p>
                            <div className="mt-auto flex flex-wrap gap-2 text-[11px] text-gray-200">
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Solar harvesting
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    3&ndash;5 year lifespan
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    BLE to mobile app
                                </span>
                            </div>
                        </article>
                    </Link>

                    {/* IC7+ */}
                    <Link
                        to="/telematics?device=ic7plus"
                        className="block h-full"
                        data-aos="fade-up"
                    >
                        <article className="flex flex-col h-full rounded-2xl bg-gray-900 bg-opacity-90 border border-gray-700 shadow-xl p-6 transition transform hover:-translate-y-1 hover:shadow-2xl hover:border-yellow-400">
                            <div className="flex items-center mb-4">
                                <img
                                    src={IC7PlusLogo}
                                    alt="IC7+ logo"
                                    className="h-10 w-auto mr-3"
                                />
                                <div>
                                    <h3 className="text-base sm:text-lg font-semibold text-white">
                                        Stand-alone analytics
                                    </h3>
                                    <p className="text-xs text-yellow-400 mt-1">
                                        Solar-powered with integrated cellular modem.
                                    </p>
                                </div>
                            </div>
                            <p className="text-sm sm:text-base text-gray-100 leading-relaxed mb-4">
                                Combines the benefits of IC7 with onboard cellular connectivity, enabling near real-time data without reliance on a paired smartphone.
                            </p>
                            <div className="mt-auto flex flex-wrap gap-2 text-[11px] text-gray-200">
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Solar + cellular
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Near real-time events
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Enhanced sensors
                                </span>
                            </div>
                        </article>
                    </Link>

                    {/* Microphone-based device */}
                    <Link
                        to="/telematics?device=icx"
                        className="block h-full"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <article className="flex flex-col h-full rounded-2xl bg-gray-900 bg-opacity-90 border border-gray-700 shadow-xl p-6 transition transform hover:-translate-y-1 hover:shadow-2xl hover:border-purple-400">
                            <div className="flex items-center mb-4 justify-between">
                                <div>
                                    <h3 className="text-base sm:text-lg font-semibold text-white">
                                        Collision detection device
                                    </h3>
                                    <p className="text-xs text-blue-300 mt-1">
                                        Acoustic and vibration sensing technology
                                    </p>
                                </div>
                            </div>
                            <p className="text-sm sm:text-base text-gray-100 leading-relaxed mb-4">
                                A sensing device tuned for automotive acoustic and vibration signatures, designed to add multi-sensor context and improve incident and collision understanding.
                            </p>
                            <div className="mt-auto flex flex-wrap gap-2 text-[11px] text-gray-200">
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Acoustic signal capture
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Incident &amp; collision context
                                </span>
                                <span className="inline-flex rounded-full bg-gray-800 px-3 py-1">
                                    Outperforms generic mic add-ons
                                </span>
                            </div>
                        </article>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default AboutAndSolutions;
